export const convertStatus = (status, alias) => {
  if (!alias) return status;

  return alias[status] || status;
};

